'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    'en-us': {
        selectPlaceHolder: 'Please select',
        comboboxPlaceHolder: 'Please input'
    },
    'zh-cn': {
        selectPlaceHolder: '请选择',
        comboboxPlaceHolder: '请输入'
    },
    'zh-tw': {
        selectPlaceHolder: '請選擇',
        comboboxPlaceHolder: '請輸入'
    }
};
module.exports = exports['default'];